<template>
  <div class="gerar-novo-pedido-inicio">
    <g-card :temCabecalho="false">
        <div class="novo-pedido-inicio">
          <img class="imagem-cabecalho" src="@/assets/imgs/caixa.png" />

          <div class="titulo-inicio-fluxos"> Gerar Novo Pedido </div>
          <div class="subtitulo-fluxos"> Pesquise e selecione qual orçamento você deseja converter em um pedido </div>

          <g-form>
            <div class="container">
              <div class="numero-solicitacao">
                <div class="titulo-conteudo-filtros"> Número da Solicitação </div>
                <PInputText 
                class="numero-solicitacao-input input-label" 
                v-model="filtroNovoPedido.NumeroSolicitacao"
                placeholder="Insira o Nº da Solicitação"
                />
              </div>

              <div class="codigo-produto">
                <div class="titulo-conteudo-filtros"> Produto </div>
                <PInputText 
                class="codigo-produto-input input-label" 
                v-model="filtroNovoPedido.CodigoProduto"
                placeholder="Código"
                />
              </div>
    
              <div class="nome-produto">
                <div class="titulo-conteudo-filtros"> Nome do Produto </div>
                <PDropDown
                class="nome-produto-input input-label" 
                v-model="filtroNovoPedido.NomeProduto"
                placeholder="Insira o nome de produto"
                optionLabel="labelProduto"
                optionValue="produtoId"
                @change="getCodigo($event.value)"
                @filter="getProduto($event.value)"
                :filter="true"
                :options="ProdutoArray"
                >
                <template #option="slotProps">
                    <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
                </template>
                </PDropDown>
              </div>

              <div class="produto-novo">
                <div class="titulo-conteudo-filtros"> Produto Novo </div>
                <PDropDown
                class="nome-produto-input input-label" 
                v-model="filtroNovoPedido.ProdutoNovo"
                placeholder="Insira o nome de produto"
                optionLabel="labelProduto"
                optionValue="produtoId"
                @filter="getProdutoNovo($event.value)"
                :filter="true"
                :options="ProdutoNovoArray"
                />
              </div>

              <div class="">
                <div class="titulo-conteudo-filtros"> Linha de Produção </div>
                <PDropDown 
                  class="linha-producao-input input-label" 
                  :options="LinhaProducaoArray"
                  v-model="filtroNovoPedido.LinhaProduto"
                  :filter="true"
                  placeholder="Selecione"
                  optionLabel="nomeLinha"
                  optionValue="nomeLinha"
                />
              </div>

              <div class="cliente">
                <div class="titulo-conteudo-filtros"> Cliente </div>
                <!-- <PDropDown 
                class="cliente-input input-label"
                    v-model="filtroNovoPedido.ClienteId"
                    :options="ClientesArray"
                    optionLabel="nomeFantasia"
                    :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                    :filter="true"
                    optionValue="id"
                    placeholder="Selecione o Cliente"
                    @filter="buscarClientes($event.value)"
                >
                <template #option="slotProps">
                    <cliente-dropdown-item
                      :dadosCliente="slotProps.option"
                    ></cliente-dropdown-item>
                  </template>
                </PDropDown> -->
                <cliente-dropdown 
                  class="p-dropdown cliente"
                  v-model="filtroNovoPedido.ClienteId"
                  :empresaId="filtroNovoPedido.UnidadeId"
                  :representanteId="this.$store.state.representanteSelecionadoId"
                />
              </div>

              <div class="data-emissao">
                  <div class="titulo-conteudo-filtros"> Período de Emissão </div>
                  <div class="input-data">
                      <div class="data-inicio">
                          <g-date-input
                          class="data-emissao-inicio-input input-label"
                          placeholderinput="Data Início"
                          alturainput = "40px"
                          largurainput = "100%"
                          tamanhobotao = "35px"
                          v-model="filtroNovoPedido.DataInicio"
                          retornaDateTime
                          :dataPassadas="true"
                          ></g-date-input>
                      </div>
                      <div class="data-periodo"> à </div>
                      <div class="data-termino">
                          <g-date-input
                          class="data-emissao-termino-input input-label"
                          placeholderinput="Data Término"
                          alturainput = "40px"
                          largurainput = "100%"
                          tamanhobotao = "35px"
                          v-model="filtroNovoPedido.DataTermino"
                          retornaDateTime
                          :dataPassadas="true"
                          ></g-date-input>
                      </div>
                  </div>
              </div>

              <div class="unidade">
                <div class="titulo-conteudo-filtros"> Unidade </div>
                <PDropDown 
                  class="unidade-input input-label unidade" 
                  v-model="filtroNovoPedido.UnidadeId"
                  :options="EmpresaArray"
                  optionLabel="nome"
                  optionValue="id"
                  :filter="true"
                  placeholder="TODAS"
                />
              </div>
              <div class="status">
                <div class="titulo-conteudo-filtros"> Status </div>
                <PDropDown 
                  class="status-input input-label" 
                  v-model="filtroNovoPedido.Status"
                  :options="StatusArray"
                  optionLabel="text"
                  optionValue="value"
                  placeholder="Selecione"
                />
              </div>

              <div class="ordenacao">
                <div class="titulo-conteudo-filtros"> Ordenação </div>
                <PDropDown 
                  class="status-input input-label" 
                  v-model="filtroNovoPedido.Ordenacao"
                  :options="ordenacaoArray"
                  optionLabel="text"
                  optionValue="value"
                  placeholder="Selecione"
                />
              </div>

              <div class="pendentes-disposicao">
                <div class="pendentes-disposicao-titulo titulo-conteudo-filtros"> Pendentes de Disposição </div>
                <PInputText 
                class="pendentes-disposicao-input input-label" 
                v-model="filtroNovoPedido.Periodo"
                placeholder="Insira o Período"
                />
              </div>
            </div>
          </g-form>

          <div class="alinha-button-fluxo">
            <div class="button-fluxo">
              <g-button
              tipo="amarelo" 
              negritoTexto 
              altura="35px"
              largura="100%"
              @click.once="Continuar"
            >
            CONTINUAR
            </g-button>
            </div>
          </div>
      </div>
    </g-card>
  </div>
</template>

<script>
import GerarNovoPedidoInicio from "./GerarNovoPedidoInicio.js";
export default GerarNovoPedidoInicio;
</script>

<style scoped>
.imagem-cabecalho{
  width: 149.33px;
}
.botao {
  display: flex;
  justify-content: center;
}
.container-form {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.text-left {
  text-align: initial;
}


:deep(.custom-p-input) {
  width: 100%;
}

.parent {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.Titulo-Inicial {
  text-align: center;
  font: normal normal 600 20px/31px Montserrat;
  color: #4f2c19;
  opacity: 1;
  /* margin-top: 10px;; */
}
.Subtitulo-Inicial {
  text-align: center;
  font: normal normal normal 12px/19px Montserrat;
  color: #8a8a8a;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-subtitulo {
  margin: 0 auto;
  width: 80%;
}
.inputs-in {
  width: 75%;
}

.proposta-img-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-proposta-img {
  /* margin-top: 20%;
  margin-left: 25%; */
  width: 40vw;
}

.continuar {
  margin-top: 30px;
}

.titulo {
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  font-weight: bold;
  white-space: nowrap;
}

.data-emissao{
  color: #747474;
  font-family: Montserrat;
}

.input-label {
  margin-bottom: 15px;
}

.produto-input {
  width: 100%;
}

@media (min-width: 310px) {
  .novo-pedido-inicio {
    margin-top: 60px;
  }
  .continuar {
    width: 100%;
    margin: 30px 10px auto;
  }

  .container{
    display: flex;
    flex-direction: column;
  }

  .data-emissao-input{
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: 100%;
    grid-column-gap: 4%;
  }

  .data-emissao-inicio { grid-area: 1 / 1 / 2 / 2; }
  .data-emissao-a { grid-area: 1 / 2 / 2 / 3; align-self: center; }
  .data-emissao-termino { grid-area: 1 / 3 / 2 / 4; }

  .numero-solicitacao-input, .codigo-produto-input, .nome-produto-input, .produto-novo-input, .linha-producao-input, .data-inicio, .data-termino, .unidade-input, .cliente-input, .status-input, .ordenacao-input, .pendentes-disposicao-input{
    width: 100%;
  }
}

@media (min-width: 368px) {
  :deep(.g-card-conteudo) {
    padding-bottom: 50px;
  }
  .continuar {
    margin: 30px 10px auto;
  }
}

@media (min-width: 600px) {
  .continuar {
    width: 240px;
    margin: 30px 20px auto;
  }
  .container{
    display: flex;
    flex-direction: column;
  }

  .data-emissao-input{
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: 100%;
    grid-column-gap: 4%;
  }

}

@media (max-width: 801px) {
  .container{
    display: flex;
    flex-direction: column;
  }

  .data-emissao-input{
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: 100%;
    grid-column-gap: 4%;
  }
}

@media(min-width: 802px){
  .container {
  display: grid;
  grid-template-columns: 30% 15% 20% 28%;
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 20px;
  grid-row-gap: 15px;
  }
  .numero-solicitacao { grid-area: 1 / 1 / 2 / 2; }
  .codigo-produto { grid-area: 1 / 2 / 2 / 3; }
  .nome-produto { grid-area: 1 / 3 / 2 / 4; }
  .produto-novo {grid-area: 1 / 4 / 2 / 5}
  .linha-producao{grid-area: 2 / 1 / 3 / 2;}
  .cliente{grid-area: 2 / 2 / 3 / 4;}
  .periodo-emissao{grid-area: 2 / 4 / 3 / 5;}
  .unidade{grid-area: 3 / 1 / 4 / 2;}
  .status{grid-area: 3 / 2 / 4 / 3;}
  .ordenacao{grid-area: 3 / 3 / 4 / 4;}
  .pendentes-disposicao{grid-area: 3 / 4 / 4 / 5;}
}

@media (min-width: 1025px) {
  .novo-pedido-inicio {
    margin-top: 60px;
  }
  .card-proposta-img {
    /* margin-top: 20%;
   margin-left: 25%; */
    width: 10vw;
  }
}

@media (min-width: 1281px) {
  .Subtitulo-Inicial {
    font: normal normal normal 13px/19px Montserrat;
    letter-spacing: 0px;
    color: #8a8a8a;
    opacity: 1;
  }

  .largura-maxima {
    width: 60%;
  }
}

@media (min-width: 1400px) {
  .Subtitulo-Inicial {
    font: normal normal normal 13px/19px Montserrat;
    letter-spacing: 0px;
    color: #8a8a8a;
    opacity: 1;
  }

  .largura-maxima {
    width: 40%;
  }
}
</style>
